<template>
  <div class="container-fluid">
    <breadcrumbs :current="getCompany.companyName" v-if="isAdmin"></breadcrumbs>
    <div v-if="showSpinner" class="spinner-wrap">
      <spinner />
    </div>
    <div v-if="!showSpinner">
      <div class="card">
        <div class="card-body">
          <div class="d-flex no-block justify-center">
            <h4 class="font-medium text-inverse">{{getCompany.companyName}}</h4>
            <div class="spacer"></div>
            <div class="text-right">
              <span>Balance:</span>
              <span v-for="(balance, index) of balances" class="pl-0 mt-2" :key="index">
                <span
                  class="h6 ml-2"
                  :class="{ 'text-danger': balance.balance < 0 }"
                >{{ balance.balance | currency }}</span>
                <span v-if="balances.length > index+1">,</span>
              </span>
            </div>
          </div>
        </div>
        <b-tabs nav-class="customtab">
          <reoute-tab
            class="card-body"
            name="detail"
            title="Detail"
            @click="openTab('company')"
            active
          >
            <form>
              <b-form-group
                horizontal
                :label-cols="3"
                id="campanyName"
                label="Company name"
                label-for="campanyName"
              >
                <input
                  id="campanyName"
                  type="text"
                  v-model.trim="getCompany.companyName"
                  placeholder="Enter company name"
                  v-validate="'required'"
                  data-vv-as="Company Name"
                  name="companyName"
                  class="form-control"
                  :class="{'is-invalid': errors.has('companyName')}"
                  autofocus
                />
                <span
                  v-show="errors.has('companyName')"
                  class="error-message"
                >{{ errors.first('companyName') }}</span>
              </b-form-group>
              <b-form-group
                horizontal
                :label-cols="3"
                id="website"
                label="Website"
                label-for="website"
              >
                <input
                  id="website"
                  type="text"
                  v-model="getCompany.website"
                  placeholder="Enter website"
                  data-vv-as="Website"
                  name="website"
                  class="form-control"
                  :class="{'is-invalid': errors.has('website')}"
                />
                <span
                  v-show="errors.has('website')"
                  class="error-message"
                >{{ errors.first('website') }}</span>
              </b-form-group>
              <b-form-group
                horizontal
                :label-cols="3"
                id="address"
                label="Address"
                label-for="address"
              >
                <textarea
                  class="form-control main-textarea"
                  rows="3"
                  v-model="getCompany.address"
                  placeholder="Enter address"
                ></textarea>
              </b-form-group>
              <b-form-group
                horizontal
                :label-cols="3"
                id="description"
                label="Description"
                label-for="description"
              >
                <textarea
                  class="form-control main-textarea"
                  rows="3"
                  v-model="getCompany.description"
                  placeholder="Enter description"
                ></textarea>
              </b-form-group>
              <b-form-group id="currency">
                <div class="form-group row">
                  <label class="col-md-3">Currency</label>
                  <div class="col-md-9">
                    <select
                      v-model="currency"
                      class="form-control"
                      id="company-filter"
                      name="currency"
                      data-vv-as="Currency"
                      v-validate="'required'"
                      :disabled="!isAdmin"
                      :class="{'is-invalid': errors.has('currency')}"
                    >
                      <option selected disabled value>Select currency</option>
                      <option
                        v-for="curr of currencies"
                        :key="curr.id"
                        :value="+curr.id"
                      >{{curr.name}}</option>
                    </select>
                    <span
                      v-show="errors.has('currency')"
                      class="error-message"
                    >{{ errors.first('currency') }}</span>
                  </div>
                </div>
              </b-form-group>
              <b-form-group id="status">
                <div class="form-group row">
                  <label class="col-md-3">Active</label>
                  <div class="col-md-9">
                    <switches v-model="getCompany.status" color="green"></switches>
                  </div>
                </div>
              </b-form-group>
              <b-form-group>
                <div class>
                  <button
                    type="button"
                    @click="onSubmit('onCompanyEdit')"
                    class="btn btn-info text-right"
                  >Save</button>
                  <!--:disabled="disabled"-->
                </div>
              </b-form-group>
            </form>
          </reoute-tab>
          <reoute-tab
            name="plan"
            title="Plan"
            class="card-body"
            id="tab-plan"
            @click="openTab('plan')"
          >
            <form style="max-width: 400px;">
              <div class="row pb-4 pt-3">
                <div class="col-md-7">Currency</div>
                <div class="col-md-5 text-info">{{currencyObj.name}} ({{currencyObj.code}})</div>
              </div>
              <b-form-group
                horizontal
                :label-cols="7"
                id="balanceLimit"
                label="Balance Limit"
                label-for="balanceLimit"
              >
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">$</span>
                  </div>
                  <input
                    id="balanceLimit"
                    type="number"
                    v-model="balanceLimit"
                    :disabled="!isAdmin"
                    placeholder="Enter amount"
                    name="balanceLimit"
                    class="form-control"
                    autofocus
                  />
                </div>
              </b-form-group>
              <b-form-group
                horizontal
                :label-cols="7"
                id="newRequestPrice"
                label="Price per New Request"
                label-for="newRequestPrice"
              >
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">$</span>
                  </div>
                  <input
                    id="newRequestPrice"
                    type="number"
                    v-model="newRequest"
                    :disabled="!isAdmin"
                    placeholder="Enter amount"
                    class="form-control"
                  />
                </div>
              </b-form-group>
              <b-form-group
                horizontal
                :label-cols="7"
                id="dataPointPrice"
                label="Price per Data Point"
                label-for="dataPointPrice"
              >
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">$</span>
                  </div>
                  <input
                    id="dataPointPrice"
                    type="number"
                    v-model="dataPoint"
                    :disabled="!isAdmin"
                    placeholder="Enter amount"
                    class="form-control"
                  />
                </div>
              </b-form-group>
              <b-form-group
                horizontal
                :label-cols="7"
                id="notesPrice"
                label="Price per Notes"
                label-for="notesPrice"
              >
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">$</span>
                  </div>
                  <input
                    id="notesPrice"
                    type="number"
                    v-model="notes"
                    :disabled="!isAdmin"
                    placeholder="Enter amount"
                    class="form-control"
                  />
                </div>
              </b-form-group>
              <b-form-group
                horizontal
                :label-cols="7"
                id="completedLeadPrice"
                label="Price per Completed Lead"
                label-for="completedLeadPrice"
              >
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">$</span>
                  </div>
                  <input
                    id="completedLeadPrice"
                    type="number"
                    v-model="lead"
                    :disabled="!isAdmin"
                    placeholder="Enter amount"
                    class="form-control"
                  />
                </div>
              </b-form-group>
              <b-form-group
                horizontal
                :label-cols="7"
                id="partialLeadPrice"
                label="Price per Partial Lead"
                label-for="partialLeadPrice"
              >
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">$</span>
                  </div>
                  <input
                    id="partialLeadPrice"
                    type="number"
                    v-model="partialLead"
                    :disabled="!isAdmin"
                    placeholder="Enter amount"
                    class="form-control"
                  />
                </div>
              </b-form-group>
              <b-form-group
                horizontal
                :label-cols="7"
                id="orderAmount"
                label="Amount per Order"
                label-for="partialLeadPrice"
              >
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">$</span>
                  </div>
                  <input
                    id="orderAmount"
                    type="number"
                    v-model="orderAmount"
                    :disabled="!isAdmin"
                    placeholder="Enter amount"
                    class="form-control"
                  />
                </div>
              </b-form-group>
              <b-form-group
                horizontal
                :label-cols="7"
                id="orderPercent"
                label="Percent per Order"
                label-for="partialLeadPrice"
              >
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">%</span>
                  </div>
                  <input
                    id="orderPercent"
                    type="number"
                    v-model="orderPercent"
                    :disabled="!isAdmin"
                    placeholder="Enter percent"
                    class="form-control"
                  />
                </div>
              </b-form-group>
              <b-form-group>
                <div class>
                  <button
                    type="button"
                    v-if="isAdmin"
                    @click="onSubmit('onPlanEdit')"
                    class="btn btn-info text-right"
                  >Save</button>
                </div>
              </b-form-group>
            </form>
          </reoute-tab>
          <reoute-tab
            name="transactions"
            id="tab-transactions"
            title="Transactions"
            class="card-body"
            @click="openTab('transactions')"
          >
            <div>
              <router-link
                v-if="isAdmin"
                tag="button"
                class="btn btn-info float-right"
                :to="{ name: 'NewTransaction' }"
              >
                <i class="mdi mdi-plus"></i> New Transaction
              </router-link>
            </div>
            <DataTable
              :columns="transactions.headers"
              fieldName="transactions"
              :query="transactions.body"
              :params="{companyId: +id}"
              ref="transactionTable"
              placeholder="Search by Transaction amount"
            >
              <span slot="id" slot-scope="props">{{ props.row.id }}</span>
              <span slot="leadId" slot-scope="props">
                <router-link
                  @click.stop
                  :to="{ name: 'LeadDetails', params: { id: props.row.leadId } }"
                >{{ props.row.leadId }}</router-link>
              </span>
              <span
                slot="created"
                slot-scope="props"
              >{{ props.row.created | moment("MMM Do YYYY, h:mm:ss a") }}</span>
              <span slot="createdBy" slot-scope="props">{{ props.row.createdBy}}</span>
              <span slot="notes" slot-scope="props">{{ props.row.notes }}</span>
              <div
                slot="currency"
                slot-scope="props"
                class="text-center"
              >{{ props.row.currency || '----' }}</div>
              <div
                slot="amount"
                slot-scope="props"
                class="text-right"
              >{{ props.row.amount | currency }}</div>
            </DataTable>
          </reoute-tab>
          <reoute-tab name="billing" title="Billing" class="card-body" @click="openTab('billing')">
            <div>
              <router-link tag="button" class="btn btn-info float-right" :to="{ name: 'NewCard' }">
                <i class="mdi mdi-plus"></i> Add New Card
              </router-link>
            </div>
            <DataTable
              :columns="billing.headers"
              fieldName="billing"
              :query="billing.body"
              :hideSearch="true"
              ref="billingTable"
              :variables="variables"
            >
              <div class="las4" slot="last4" slot-scope="props">..{{props.row.last4}}</div>
              <div slot="actions" slot-scope="props" class="actions">
                <router-link
                  tag="button"
                  class="btn btn-success btn-sm"
                  v-if="isAdmin"
                  :to="{ name: 'NewPayment', query: { cardId: props.row.id, cardNumber: props.row.last4 } }"
                >Pay With</router-link>
                <button
                  class="btn btn-inverse btn-sm"
                  v-if="props.row.id !== getCompany.stripeSourceId"
                  @click="setDefaultCard(props.row.id)"
                >Make Default</button>
                <div v-else>Default Card</div>
              </div>
            </DataTable>
          </reoute-tab>
        </b-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import omit from 'lodash/omit';
import Switches from 'vue-switches';
import EDIT_COMPANY from '@/graphql/Companies/EditCompany.gql';
import CURRENCIES from '@/graphql/Currencies/Currencies.gql';
import PLAN from '@/graphql/Companies/CompanyPlan.gql';
import EDIT_PLAN from '@/graphql/Companies/EditCompanyPlan.gql';
import TRANSACTIONS from '@/graphql/Transactions/Transactions.gql';
import BILLING from '@/graphql/Billing/Billing.gql';

import Spinner from '@/components/Spinner';
import DataTable from '@/components/DataTable';

export default {
  name: 'CompanyDetails',
  components: {
    Spinner,
    Switches,
    DataTable,
  },
  data() {
    return {
      id: this.$route.params.id,
      showSpinner: 0,
      currencies: [],
      isLoaded: false,
      plan: {
        balanceLimit: 0,
        newRequest: 0,
        dataPoint: 0,
        notes: 0,
        lead: 0,
        partialLead: 0,
        orderAmount: 0,
        orderPercent: 0,
      },
      transactions: {
        headers: [
          { field: 'id', title: 'Id' },
          { title: 'Lead', field: 'leadId' },
          { title: 'Date', field: 'created' },
          { title: 'User', field: 'createdBy' },
          { title: 'Description', field: 'notes' },
          { title: 'Currency', field: 'currency' },
          { title: 'Amount', field: 'amount' },
        ],
        body: TRANSACTIONS,
      },
      billing: {
        headers: [
          { title: 'Name', field: 'name' },
          { title: 'Email', field: 'email' },
          { title: 'Brand', field: 'brand' },
          { title: 'Card', field: 'last4' },
          { title: 'Exp. Date', field: 'exp' },
          { title: 'Actions', field: 'actions', skipSorting: true },
        ],
        body: BILLING,
      },
    };
  },
  computed: {
    ...mapGetters([
      'getAuthUser',
      'isUserAdmin',
      'isUserClient',
      'getCompany',
      'getCompanyBalances',
    ]),
    currencyObj: {
      get() {
        const currencyId = this.currency || 0;
        const result = this.currencies.find(obj => +obj.id === +currencyId);
        return result || {};
      },
    },
    currency: {
      get() {
        return (this.getCompany && this.getCompany.currency) || '';
      },
      set(currency) {
        this.setCompany({ ...this.getCompany, currency });
      },
    },
    balanceLimit: {
      get() {
        return (this.plan && this.plan.balanceLimit) || '';
      },
      set(val) {
        this.plan.balanceLimit = val;
      },
    },
    newRequest: {
      get() {
        return (this.plan && this.plan.newRequest) || '';
      },
      set(val) {
        this.plan.newRequest = val;
      },
    },
    dataPoint: {
      get() {
        return (this.plan && this.plan.dataPoint) || '';
      },
      set(val) {
        this.plan.dataPoint = val;
      },
    },
    notes: {
      get() {
        return (this.plan && this.plan.notes) || '';
      },
      set(val) {
        this.plan.notes = val;
      },
    },
    lead: {
      get() {
        return (this.plan && this.plan.lead) || '';
      },
      set(val) {
        this.plan.lead = val;
      },
    },
    partialLead: {
      get() {
        return (this.plan && this.plan.partialLead) || '';
      },
      set(val) {
        this.plan.partialLead = val;
      },
    },
    orderPercent: {
      get() {
        return (this.plan && this.plan.orderPercent) || '';
      },
      set(val) {
        this.plan.orderPercent = val;
      },
    },
    orderAmount: {
      get() {
        return (this.plan && this.plan.orderAmount) || '';
      },
      set(val) {
        this.plan.orderAmount = val;
      },
    },
    variables() {
      return {
        id: +this.id,
      };
    },
    isClient() {
      return this.isUserClient;
    },
    isAdmin() {
      return this.isUserAdmin;
    },
    balances() {
      return this.getCompanyBalances;
    },
  },
  mounted() {
    this.fetchCompany(+this.$route.params.id);
    this.fetchCompanyBalances(+this.$route.params.id);
  },
  watch: {
    '$route.params.id'(newId) {
      this.fetchCompany(+newId);
      this.fetchCompanyBalances(+newId);
    },
  },
  methods: {
    ...mapMutations(['setCompany']),
    ...mapActions(['fetchCompany', 'fetchCompanyBalances']),
    async onSubmit(tab) {
      // TODO temporary solution
      try {
        if (tab === 'onCompanyEdit') {
          const valid = await this.$validator.validateAll();
          if (!valid) {
            return;
          }
        }
      } catch (e) {
        return;
      }

      this[tab]();
    },
    onCompanyEdit() {
      this.apolloMutateRequest({
        mutation: EDIT_COMPANY,
        variables: {
          id: this.id,
          input: omit(this.getCompany, ['overdue', 'overdueSince', 'id']),
        },
        refetchQueries: ({ data }) => {
          const response = data.updateCompany;
          return response && response.success ? ['companies'] : [];
        },
        success: () => {
          this.setCompany(this.getCompany);
          this.$notify({
            group: 'success',
            type: 'success',
            text: 'Company was edited',
          });
        },
        error: e => {
          if (e.message.includes('ER_DUP_ENTRY')) {
            this.$validator.errors.add('companyName', 'This Company Name already exists');
          } else {
            this.$notify({
              group: 'error',
              type: 'error',
              text: e.message,
            });
          }
        },
      });
    },
    onPlanEdit() {
      this.apolloMutateRequest({
        mutation: EDIT_PLAN,
        variables: {
          id: this.id,
          input: {
            balanceLimit: parseFloat(this.plan.balanceLimit),
            newRequest: parseFloat(this.plan.newRequest),
            dataPoint: parseFloat(this.plan.dataPoint),
            notes: parseFloat(this.plan.notes),
            lead: parseFloat(this.plan.lead),
            partialLead: parseFloat(this.plan.partialLead),
            orderAmount: parseFloat(this.plan.orderAmount),
            orderPercent: parseFloat(this.plan.orderPercent),
          },
        },
        refetchQueries: ({ data }) => {
          const response = data.updatePlan;
          return response && response.success ? ['plan'] : [];
        },
        success: () => {
          this.$notify({
            group: 'success',
            type: 'success',
            text: 'Plan was edited',
          });
        },
        error: e => {
          this.$notify({
            group: 'error',
            type: 'error',
            text: e.message,
          });
        },
      });
    },
    apolloMutateRequest(options) {
      this.$apollo
        .mutate({
          mutation: options.mutation,
          variables: options.variables,
          refetchQueries: options.refetchQueries,
        })
        .then(options.success)
        .catch(options.error);
    },
    openTab(tabName) {
      if (this.isLoaded && tabName !== 'transactions' && tabName !== 'billing') {
        this.$apollo.queries[tabName].refresh();
      }
      if (tabName === 'transactions') {
        this.$refs.transactionTable.onRefreshData();
      }
      if (tabName === 'billing') {
        this.$refs.billingTable.onRefreshData();
      }
    },
    setDefaultCard(stripeSourceId) {
      this.setCompany({ ...this.getCompany, stripeSourceId });
      this.apolloMutateRequest({
        mutation: EDIT_COMPANY,
        variables: {
          id: this.id,
          input: omit(this.getCompany, ['overdue', 'overdueSince', 'id']),
        },
        error: e => {
          this.$notify({
            group: 'error',
            type: 'error',
            text: e.message,
          });
        },
      });
    },
  },
  apollo: {
    currencies: {
      query: CURRENCIES,
      fetchPolicy: 'cache-and-network',
      result({ data, loading }) {
        if (!loading) {
          this.currencies = data.currencies;
        }
      },
    },
    plan: {
      query: PLAN,
      fetchPolicy: 'cache-and-network',
      variables() {
        return {
          id: +this.id,
        };
      },
      result({ data, loading }) {
        if (!loading) {
          this.plan = {
            balanceLimit: data.plan && data.plan.balanceLimit,
            newRequest: data.plan && data.plan.newRequest,
            dataPoint: data.plan && data.plan.dataPoint,
            notes: data.plan && data.plan.notes,
            lead: data.plan && data.plan.lead,
            partialLead: data.plan && data.plan.partialLead,
            orderPercent: data.plan && data.plan.orderPercent,
            orderAmount: data.plan && data.plan.orderAmount,
          };
        }
      },
      skip() {
        return !this.id;
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.balance-list {
  list-style: none;
  padding: 0;
  margin: 0;
  text-align: left;
}
.actions {
  display: flex;
  justify-content: center;
  align-items: center;
}
.actions button {
  margin: 0 5px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Companies/CompanyDetails.vue